module.exports = __webpack_public_path__ + "static/landing-banner-a5201b8bf72bb644fb242e43b95f0443.png";